module.exports = __webpack_public_path__ + "img/trash.8c3f7ba1.svg";